<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="toc">
<a id="page11"></a>
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryName"><a href="#/xhtml/chapter01#ch01">History on a Personal Note</a></p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryName"><a href="#/xhtml/chapter02#ch02">For Widgit Stands</a></p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryName"><span href="#/xhtml/chapter03#ch03" title="Link target outside of Sample">Money Honey</span></p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryName"><span href="#/xhtml/chapter04#ch04" title="Link target outside of Sample">Faith Is a Girl’s Name</span></p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryName"><span href="#/xhtml/chapter05#ch05" title="Link target outside of Sample">In the Beginning</span></p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryName"><span href="#/xhtml/chapter06#ch06" title="Link target outside of Sample">Carlotta</span></p></div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryName"><span href="#/xhtml/chapter07#ch07" title="Link target outside of Sample">Halfway to Farmville</span></p></div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryName"><span href="#/xhtml/chapter08#ch08" title="Link target outside of Sample">White Houses</span></p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryName"><span href="#/xhtml/chapter09#ch09" title="Link target outside of Sample">Courtship</span></p></div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryName"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Jewish but Not Really</span></p></div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryName"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">The Zen of Driving</span></p></div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryName"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Viewing Stacy from Above</span></p></div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryName"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Exclusive Pleasures</span></p></div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryName"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">A Full Life of a Different Nature</span></p></div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryName"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">The Cape Man</span></p></div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryName"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Rural Delivery</span></p></div>
<div class="contentsEntry" id="ack_01">
<p class="contentsEntryName"><span href="#/xhtml/ack#ack01" title="Link target outside of Sample">Acknowledgments</span></p></div>
<div class="contentsEntry" id="ata_01">
<p class="contentsEntryName"><span href="#/xhtml/ata#ata01" title="Link target outside of Sample">About the Author</span></p></div>
<div class="contentsEntry" id="rev_01">
<p class="contentsEntryName"><span href="#/xhtml/praise#rev01" title="Link target outside of Sample">Praise</span></p></div>
<div class="contentsEntry" id="adc_01">
<p class="contentsEntryName"><span href="#/xhtml/adc#adc01" title="Link target outside of Sample">Other Books by Binnie Kirshenbaum</span></p></div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName"><span href="#/xhtml/copy#cop01" title="Link target outside of Sample">Copyright</span></p></div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName"><span href="#/xhtml/atp#atp01" title="Link target outside of Sample">About the Publisher</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a9f7adfa